import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'

export default class RequiredLoginException extends BaseErrorHandler {
    protected AlertType: AlertTypeEnum = AlertTypeEnum.ERROR;
    protected Code: string = "RequiredLogin";
    protected ShowMessage: boolean = false;

    customizeAction(): void {
        // let {currentRoute} = router;
        // if (currentRoute.value.path !== '/' && currentRoute.value.path !== '/login') {
        //     let VITE_APP_GATEWAYSALIASNAME = import.meta.env.VITE_APP_GATEWAYSALIASNAME;
        //     let global = getGlobalThis();
        //     global.location.href = VITE_APP_GATEWAYSALIASNAME !== "/" ? `/${VITE_APP_GATEWAYSALIASNAME}/login` : VITE_APP_GATEWAYSALIASNAME + "login";
        // }
    }
}
